import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from 'presentation/components/icons/IconContainer';
import { CLOSE_ICON_TYPE } from 'enums/configuration';

import styles from 'presentation/components/styles/CloseButton.css';

export default function CloseButton({ className, iconType, onClick, onKeyDown, title }) {
  let cx = classnames.bind(styles);
  let classes = cx(styles.closeButton, className);
  return (
    <div tabIndex="0" className={classes} aria-label="close" role="button" onKeyDown={onKeyDown} onClick={onClick}>
      <IconContainer className={styles.closeChatIcon} viewBox="0 0 16 15" title={title} titleId="closeButtonTitleId">
        {iconType === CLOSE_ICON_TYPE.DASH_ICON ? <DashIcon /> : <XIcon />}
      </IconContainer>
    </div>
  );
}

function DashIcon() {
  return <path d="M0 8h15" strokeLinecap="square" />;
}

export function XIcon() {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8536 2.85355C14.0488 2.65829 14.0488 2.34171 13.8536 2.14645C13.6583 1.95118 13.3417 1.95118 13.1464 2.14645L8 7.29289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95119 2.34171 1.95119 2.65829 2.14645 2.85355L7.29289 8L2.14645 13.1464C1.95118 13.3417 1.95118 13.6583 2.14645 13.8536C2.34171 14.0488 2.65829 14.0488 2.85355 13.8536L8 8.70711L13.1464 13.8536C13.3417 14.0488 13.6583 14.0488 13.8536 13.8536C14.0488 13.6583 14.0488 13.3417 13.8536 13.1464L8.70711 8L13.8536 2.85355Z"
    />
  );
}

CloseButton.propTypes = {
  className: PropTypes.string,
  iconType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  setAutoFocusMinimizedChat: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
